import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import BookingFormLabelsEditor from '../components/BookingFormLabelsEditor';

const BookingFormLabelsManager = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <Link
          to="/admin?tab=settings"
          className="inline-flex items-center space-x-2 text-primary-600 hover:text-primary-700 mb-6"
        >
          <ArrowLeft size={20} />
          <span>Back to Settings</span>
        </Link>

        <BookingFormLabelsEditor />
      </div>
    </div>
  );
};

export default BookingFormLabelsManager;
